enum ChargingMode {
    IMMEDIATE = 'IMMEDIATELY',
    TIMER = 'TIMER',
}

export default ChargingMode;
